import { render, staticRenderFns } from "./dasuanbz_info.vue?vue&type=template&id=48158328&scoped=true&"
import script from "./dasuanbz_info.vue?vue&type=script&lang=js&"
export * from "./dasuanbz_info.vue?vue&type=script&lang=js&"
import style0 from "./dasuanbz_info.vue?vue&type=style&index=0&id=48158328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48158328",
  null
  
)

export default component.exports